module.exports = __webpack_public_path__ + "img/travel-insurance-filled.9ff2420.png";